import { type Page } from './constants';
import createErrors from '../createErrors';

export type Component = 'AuthorizedSections';

/**
 * Errors related to the Cart page
 */
export const Errors = createErrors<Page, Component>('Checkout')({
    AuthorizedSections: {
        GetPetsFailed: {
            severity: 'MEDIUM',
            message: 'Failed to fetch pets',
        },
        EditPetFailed: {
            severity: 'MEDIUM',
            message: 'Failed to edit pet',
        },
    },
});
